import { invoke } from "@shared/easyfy.decorators";
import filter from '@clientWebModules/filter';
import ToggleCss from '@shared/easyfy.togglecss';
  
namespace Easyfy.Web.Pages {
  @invoke
  class Category {
    static Instance: Category;
    private togglecss: ToggleCss;

    constructor() {
      Category.Instance = this;
      this.togglecss = new ToggleCss('togglecss');
    }

    onInit() {
      new filter.Filter(filter.FilterFor.Category, '[data-container="filter"]', '[data-container="paging"]', '[data-container="products"]', '[data-container="sorter"]');
    }
  }
}

export default Easyfy.Web.Pages;